import React, { useState } from 'react';
import { Accordion, Card, Button, Popover, OverlayTrigger } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { EditorState, ContentState, convertToRaw, convertFromHTML } from 'draft-js';
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';


const Risposta_visualizza = (props) => {
    const [somma, calcola_somma] = useState('');


    const popover = (
        <Popover id="popover-basic">
            <Popover.Title as="h3">Risposta</Popover.Title>
            <Popover.Content>
                <p>
                    {ReactHtmlParser(props.lista_file_mp3[props.index3].risposta)}
                </p>
            </Popover.Content>
        </Popover>
    );

    return (
        <div>
            <Accordion defaultActiveKey="0">
                <Card>

                    <Card.Header>
                        <Accordion.Toggle as={Button} variant="link" eventKey="1">
                            Risposta
                         </Accordion.Toggle>
                    </Card.Header>

                    <Accordion.Collapse eventKey="1">
                        <Card.Body>
                            <p>

                                {ReactHtmlParser(props.lista_file_mp3[props.index3].risposta)}
                            </p>
                            <p>
                                {props.lista_file_mp3[props.index3].risposta}
                            </p>

                        </Card.Body>

                    </Accordion.Collapse>
                </Card>
            </Accordion>
        </div>
    )
}

export default Risposta_visualizza;
